import styled from 'styled-components';
import Button from '../../components/Button';

const LyraCardGift = styled.div`
    cursor: pointer;
    text-align: left;
    margin-bottom: 0px;
    display: inline-block;
    padding: 10px;
    margin-bottom:20px;
    border-radius:5px;
    max-width: 100%;
    width: 100%;
    border: 1px solid ${({ theme: { gray89 } }) => gray89};
  .h-300{
    height: 300px;
  }
  .h-250{
    height: 300px;
  }
  img{
    max-width: 100%;
    width:100%;
    border-radius:10px;
    height:140px;
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
          height:120px;
    };
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
      height: auto;
      width: auto;
    };
    &.manipal-img{
      object-fit: contain;
    }
  }
  div {
    padding: 5px 10px;
    text-align:center;
    img {
      max-width: 100%;
      border-radius:5px;
    }
    span {
      color: ${({ theme: secondaryColor }) => secondaryColor};
      font-weight:600;
      font-size:13px;
      b{
        color: ${({ theme: primaryColor }) => primaryColor};
        font-weight:700;
        font-size:13px;
        &:after{
          content:'';
          margin:0px 10px;
          // border-right:#333 solid 1px;
          height: 13px;
          display: inline-block;
        }
      }
    }
    strong{
      font-size:13px;
      color:${({ theme: secondaryColor }) => secondaryColor};
      font-weight:700;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      display: inline-block;
      width: 100%;
    }
  }
  select{
      float:left;
      padding:6px;
      border:${({ theme: lightGray }) => lightGray} solid 1px;
      background: ${({ theme: lightWhite }) => lightWhite};
      width:47%;
      margin-right:6%;
      font-size:13px;
    }
    ${Button}{
      float:left;
      width:47%;
      margin:0px;
      font-size:12px;
      padding: 8px 4px;
    }
    .vourcher-Remarks{
    margin-top: 2px;
    height: 100%;
    }
    .price-button-row {
      display: flex;
      gap: 10px;
      align-items: center;
      justify-content: center;
      padding: 10px;
      .price-input {
        flex: 1;
        font-size: 13px;
      }
      ${Button} {
        flex-shrink: 0;
        font-size: 12px;
        padding: 8px 12px;
        height: auto;
      }
    }

    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[1]}) {
      height: auto !important;
      text-align: center;
      .price-button-row {
        flex-direction: column;
        align-items: stretch;
        ${Button} {
          width: 100%;
        }
  }
    };
    ${({ padding }) => padding && `padding: ${padding}`}
`;

const PopoverImage = styled.img`
  width: 400px;
`;

export { LyraCardGift, PopoverImage };



// WEBPACK FOOTER //
// client/containers/GiftCardLanding/StyledLyraCardGift.js